module.exports = __webpack_public_path__ + "img/chat_1.01d7801e.png";